import { Button, Modal, ModalInner, Text } from 'components';
import { PromotionItem } from './index';

interface DeleteModalProps {
  isOpened: boolean;
  data: PromotionItem | null;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteModal = ({ isOpened, data, onClose, onConfirm, loading = false }: DeleteModalProps) => {
  if (!isOpened || !data) return null;

  return (
    <Modal isOpened={isOpened}>
      <ModalInner className="md:w-[500px]" title="Delete Promotion" onClickClose={onClose}>
        <div className="p-6 pt-0">
          <Text size="body1" weight="regular" color="black" className="mb-4">
          이 프로모션을 삭제하시겠습니까?
          </Text>
          
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex flex-col gap-2">
              <div>
                <Text size="body2" weight="medium" color="black">Title:</Text>
                <Text size="body2" weight="regular" color="description" className="ml-2">
                  {data.title}
                </Text>
              </div>
              <div>
                <Text size="body2" weight="medium" color="black">Description:</Text>
                <Text size="body2" weight="regular" color="description" className="ml-2">
                  {data.description}
                </Text>
              </div>
              <div>
                <Text size="body2" weight="medium" color="black">Status:</Text>
                <Text size="body2" weight="regular" color="description" className="ml-2">
                  {data.isActive ? 'Active' : 'Inactive'}
                </Text>
              </div>
            </div>
          </div>

          <Text size="body2" weight="regular" color="description" className="mb-6">
            삭제된 프로모션은 복구할 수 없습니다.
          </Text>
        </div>

        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button 
            className="h-9" 
            text="Cancel" 
            onClick={onClose} 
            type="secondary" 
            size="large" 
            disabled={loading}
          />
          <Button 
            className="h-9 bg-red-600 border-red-600 hover:bg-red-700" 
            text={loading ? "Deleting..." : "Delete"} 
            onClick={onConfirm} 
            size="large" 
            disabled={loading}
          />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DeleteModal;
